// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","shareButton":"Be9zPQ","isMobile":"IYk7Uu","shareIcon":"axYHjo","children":"OUDzBS","noIcon":"Y9yKjX"};